import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogForm from "@/shared/ui/SogForm.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCheckBox from "@/shared/ui/SogCheckBox.vue";
import PersonAddressEditComponent from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import {onMounted, reactive, ref, watch} from "vue";
import {replaceWith} from "@/shared/utils/CopyTo";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {onBeforeRouteUpdate} from "vue-router";
import {useAccountStore} from "@/stores/accountStore";
import PersonAddressForm from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";

interface Props {
  person?: Person | undefined
  address?: Address | undefined
  cancelButtonText?: string
  showSaveAddress?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'EvbActivationComponent',
  props: {
    person: { default: undefined },
    address: { default: undefined },
    cancelButtonText: { default: undefined },
    showSaveAddress: { type: Boolean, default: false }
  },
  emits: ["clickCancel", "clickOk"],
  setup(__props: any, { emit: __emit }) {


const props = __props


const _emit = __emit;


const _person = reactive<Person>(new Person())
const _address = reactive<Address>(new Address())
const _saveAddress = ref(false)
const _activationDuration = ref(30)
const _accountStore = useAccountStore()
const _formActivation = ref<InstanceType<typeof SogForm> | null>(null)
const _personAddressForm = ref<InstanceType<typeof PersonAddressForm> | null>(null)
const _durationValidation: SogFormValidationRule[] = [
  {name: 'activationDuration', rules: {required: [true, "1 bis 90 Tage"], min: 1, max: 90}},
]


watch(props, () => {
    if (props.person) {
      replaceWith(props.person, _person);
    }
    if (props.address) {
      replaceWith(props.address, _address);
    }
    if (props.showSaveAddress) {
      _saveAddress.value = false;
    }
    // deep: Props sind shallowReactive – ohne deep feuert der Watch nur bei
    // Referenzwechsel, nicht wenn person/address in-place mutiert werden.
  }, {immediate: true, deep: true}
)


async function p_init() {
  const t_default = _accountStore.details?.getNumberValue(PersonDetailsId.EvbActivationDefaultDuration) ?? (_accountStore.isBranch ? 7 : 30)
  const t_max = _accountStore.details?.getNumberValue(PersonDetailsId.EvbActivationMaxDuration) ?? (_accountStore.isBranch ? 30 : _accountStore.isRoot ? 180 : 90)
  _formActivation.value.removeRules("activationDuration")
  _formActivation.value.addRules({
    name: 'activationDuration',
    rules: {required: [true, "1 bis " + t_max + " Tage"], min: 1, max: t_max}
  })
  _activationDuration.value = t_default;
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
//  await p_init()
});

function onActivationCancel() {
  _emit("clickCancel")
}

async function onActivationOk() {
  if (_formActivation.value.validate() && _personAddressForm.value.validate()) {
    _emit("clickOk", {activationDuration: _activationDuration.value, person: _person, address: _address, saveAddress: _saveAddress.value})
  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card-without-title" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogForm, {
            ref_key: "_formActivation",
            ref: _formActivation,
            validations: _durationValidation
          }, {
            default: _withCtx(() => [
              _createVNode(SogFormField, null, {
                default: _withCtx(() => [
                  _createVNode(SogNumericTextBox, {
                    modelValue: _activationDuration.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_activationDuration).value = $event)),
                    placeholder: "eVB-Gültigkeit (Tage)",
                    name: "activationDuration",
                    format: "n",
                    width: "220px"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(PersonAddressEditComponent, {
                ref_key: "_personAddressForm",
                ref: _personAddressForm,
                person: _person,
                address: _address
              }, null, 8, ["person", "address"])
            ]),
            _: 1
          }, 512),
          _withDirectives(_createVNode(SogCheckBox, {
            modelValue: _saveAddress.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_saveAddress).value = $event)),
            width: "220px",
            placeholder: "Diese Adresse für zukünftige eVB-Aktivierungen speichern"
          }, null, 8, ["modelValue"]), [
            [_vShow, !__props.showSaveAddress]
          ])
        ]),
        _: 1
      }),
      _createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-check",
            onClick: onActivationOk
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Ok ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-cancel",
            onClick: onActivationCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.cancelButtonText ?? 'Abbrechen'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})